import { useSuspenseQuery } from '@apollo/client/react';
import * as Sentry from '@sentry/react';
import { GET_UMSATZ_ABSATZ_ZIELE_BY_STANDORT_ID } from './graphql/queries';
import {
  Absatz,
  AbsatzProduktivitaet,
  Currency,
  Money,
  Umsatz,
} from '../entities';
import {
  GetUmsatzAbsatzZieleByStandortIdQuery,
  GetUmsatzAbsatzZieleByStandortIdQueryVariables,
} from '@/gql/graphql';

export function useUmsatzAbsatzZiele(
  idStandort: string,
  jahr: number,
  monat: number,
): {
  umsatzZiel?: Umsatz;
  absatzZiel?: Absatz;
  error?: string;
} {
  const { data, error } = useSuspenseQuery<
    GetUmsatzAbsatzZieleByStandortIdQuery,
    GetUmsatzAbsatzZieleByStandortIdQueryVariables
  >(GET_UMSATZ_ABSATZ_ZIELE_BY_STANDORT_ID, {
    variables: {
      standortId: idStandort,
      jahr: jahr,
      monat: monat,
    },
    fetchPolicy: 'network-only',
  });
  if (error) {
    Sentry.captureException(error);
    return { error: error?.message };
  }
  const umsatzZiel = data.controlling[0].umsatzZiel.umsatz;
  const absatzZiel = data.controlling[0].absatzZiel.absatz;

  const newUmsatzZiel = new Umsatz({
    produktivitaet: !umsatzZiel.produktivitaet
      ? null
      : new Money({
          amount: umsatzZiel.produktivitaet.amount,
          currency: Currency[umsatzZiel.produktivitaet.currency],
        }),
    wert: !umsatzZiel.wert
      ? null
      : new Money({
          amount: umsatzZiel.wert.amount,
          currency: Currency[umsatzZiel.wert.currency],
        }),
    stunden: umsatzZiel.stunden,
  });

  const newAbsatzZiel = new Absatz({
    produktivitaet: !absatzZiel.produktivitaet
      ? null
      : new AbsatzProduktivitaet({
          stueck: absatzZiel.produktivitaet.stueck,
          mpt: absatzZiel.produktivitaet.mpt,
        }),
    wert: absatzZiel.wert,
    stunden: absatzZiel.stunden,
  });

  return {
    error: undefined,
    umsatzZiel: newUmsatzZiel,
    absatzZiel: newAbsatzZiel,
  };
}
